module.exports = __webpack_public_path__ + "static/media/javascript.54d8ecb1.svg";